import React from "react";
import { Link } from "react-router-dom";

const SoftwareEngineer = () => {
  return (
    <div className="Job-listing">
      <p>
        We want to democratize coding by making it 100x easier to build
        software, so the next billion people can code. First, we’re going to
        make it so developers can build a complete scalable app in an afternoon.
        That means removing all the annoying things about building software, and
        creating an amazing development experience.
      </p>

      <p>
        We have a great <Link to="/careers/team">team</Link> so far and we’re
        hiring more Engineers in San Francisco and remotely to help build this
        out. As an engineer on our team, you’ll get to work on problems that
        impact you when you write software.
      </p>

      <p>You:</p>
      <ul>
        <li>
          Have built a wide array of products. We want to hear about them,
          including the technologies you used to build them.
        </li>
        <li>
          Are comfortable iterating rapidly. We’re a super-early stage startup –
          we need to iterate quickly to validate concepts. You need to be
          comfortable building quick hacky prototypes to throw away, but also
          good at productizing the winners later.
        </li>
        <li>
          Are interested in other things, too! If you've done other work with
          new frontend frameworks, programming languages, or compilers, we're
          happy to hear about it.
        </li>
      </ul>

      <p>
        To apply, email{" "}
        <a href="mailto:careers@darklang.com">careers@darklang.com</a>. When you
        apply, tell us about your previous work, including the technologies you
        used. We'd also like to hear what your favorite programming language is
        (and why). You may also be interested in looking at our{" "}
        <Link to="/about#values">values</Link>.
      </p>
    </div>
  );
};

export default SoftwareEngineer;
